module.exports = __webpack_public_path__ + "img/graph-icon.f089985c.svg";